import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';

@Injectable({
    providedIn: 'root'
})
export class DownloadArquivoService {

    constructor(private http: HttpClient) {}

    baixar(urlDownload: string, token?: string): Observable<Blob> {
        const headers = new HttpHeaders({
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        })

        return this.http.get(urlDownload, { responseType: 'blob', headers });
    }
        
}